// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__k6pbj","info":"Panel_info__Lqd5E","btns":"Panel_btns__hc5gr","button":"Panel_button__NWs6v"};